"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var shadows = {
    "card": "0px 0px 8px rgba(22, 22, 22, 0.12)"
};
exports.default = shadows;
//# sourceMappingURL=shadows.js.map